"use strict";

function scrollbarOnTopContent() {
  return {
    scope: {
      "columns": "=scrollbarOnTopContent"
    },
    link: function(scope, element) {
      var colunmWidth = angular.element(document.getElementsByClassName('customers-dashboard__column')).outerWidth();

      function updateScroll() {
        $div2.width(scope.columns * colunmWidth);
        // make the scroll bars the same width
        $div1.width(scope.columns * colunmWidth);

        // sync the real scrollbar with the virtual one.
        $wrapper1.scroll(function(){
          $wrapper2.scrollLeft($wrapper1.scrollLeft());
        });

        // sync the virtual scrollbar with the real one.
        $wrapper2.scroll(function(){
          $wrapper1.scrollLeft($wrapper2.scrollLeft());
        });
      }

      // creates the top virtual scrollbar
      element.wrapInner("<div class='ct-scrollbar__content' />");
      element.wrapInner("<div class='ct-scrollbar__wrapper-bottom' />");

      // contains the element with a real scrollbar
      element.prepend("<div class='ct-scrollbar__wrapper-top'><div class='ct-scrollbar__placehoder'></div></div>");

      var $wrapper1 = element.find('.ct-scrollbar__wrapper-top'),
          $div1 = element.find('.ct-scrollbar__placehoder'),
          $wrapper2 = element.find('.ct-scrollbar__wrapper-bottom'),
          $div2 = element.find('.ct-scrollbar__content');

      // force our virtual scrollbar to work the way we want.
      $wrapper1.css({
        width: "100%",
        border: "none 0px rgba(0, 0, 0, 0)",
        overflowX: "auto",
        overflowY: "hidden",
        height: "20px",
        marginBottom: "1em",
        marginTop: "-1em"
      });

      $div1.css({
        height: "20px",
      });

      $wrapper2.css({
        width: "100%",
        overflowX: "auto",
      });

      updateScroll();
    }
  };
}

angular.module('dokiv')
  .directive('scrollbarOnTopContent', scrollbarOnTopContent);




//////////////////
// WEBPACK FOOTER
// ./scripts/app/scrollbarOnTopContent.js
// module id = 269
// module chunks = 0